/* int-l4-social-feed.js: moved verbatim from sections/int-social-feed.liquid (pdp-html-weight lever 4, 2026-11-02). Do not edit here without the source note. */
document.addEventListener('DOMContentLoaded', function () {
[].forEach.call(document.querySelectorAll('[data-int-social-feed]'), function (root) {
  if (!root || root.dataset.sfInit) return;
  root.dataset.sfInit = '1';

  var grid = root.querySelector('.int-sf__grid');
  var btn  = root.querySelector('.int-sf__btn');
  var step = parseInt(root.dataset.step, 10) || 6;
  var shown = 0;
  var items = [];
  var playVideo = root.dataset.video === 'on';

  // Carousel is a CSS-media-query layout, so the class alone is not enough -
  // the same markup is a grid above 750px. Both conditions have to hold.
  function isCarousel() {
    return grid.classList.contains('int-sf__grid--carousel')
      && window.matchMedia('(max-width: 749px)').matches;
  }

  var TT = '<svg class="int-sf__badge" viewBox="0 0 24 24" fill="#fff" aria-hidden="true">'
    + '<path d="M16.6 5.8a4.3 4.3 0 0 1-1-2.8h-3v11.8a2.4 2.4 0 1 1-1.7-2.3V9.4a5.5 5.5 0 1 0 4.7 5.4V9.1a7.2 7.2 0 0 0 4.2 1.3V7.5a4.3 4.3 0 0 1-3.2-1.7z"/></svg>';
  var IG = '<svg class="int-sf__badge" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" aria-hidden="true">'
    + '<rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="#fff" stroke="none"/></svg>';

  function esc(s) {
    return String(s || '').replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function render() {
    var next = items.slice(shown, shown + step);
    var html = '';
    next.forEach(function (it) {
      if (!it.image) return;
      // First row eager so the grid paints immediately; the rest lazy.
      var loading = shown === 0 ? 'eager' : 'lazy';
      // First sentence only: social captions run to 400 chars and a wall of
      // hashtags under a photograph looks like a data dump, not an editorial.
      var line = it.caption.split('\n')[0].replace(/#\S+/g, '').trim().slice(0, 80);
      html += '<li class="int-sf__item"><a href="' + esc(it.link) + '" target="_blank" rel="noopener"'
        + ' aria-label="' + esc(it.caption.slice(0, 90) || 'View on ' + it.source) + '">'
        + '<img src="' + esc(it.image) + '" alt="' + esc(it.caption.slice(0, 120)) + '"'
        + ' loading="' + loading + '" decoding="async">'
        + (playVideo && it.video
            ? '<video class="int-sf__vid" src="' + esc(it.video) + '" muted loop playsinline'
              + ' preload="none"></video><span class="int-sf__play"></span>'
            : '')
        + '<span class="int-sf__scrim"></span>'
        + (it.source === 'tiktok' ? TT : IG)
        + (line ? '<span class="int-sf__cap">' + esc(line) + '</span>' : '')
        + '</a></li>';
    });
    grid.insertAdjacentHTML('beforeend', html);
    shown += next.length;
    btn.hidden = shown >= items.length;
  }

  // Delegated, so tiles added by "View more" are covered without rebinding.
  function wireHover() {
    grid.addEventListener('mouseenter', function (e) {
      var li = e.target.closest && e.target.closest('.int-sf__item');
      var v = li && li.querySelector('.int-sf__vid');
      if (!v) return;
      li.classList.add('is-playing');
      var p = v.play();
      if (p && p.catch) p.catch(function () { li.classList.remove('is-playing'); });
    }, true);
    grid.addEventListener('mouseleave', function (e) {
      var li = e.target.closest && e.target.closest('.int-sf__item');
      var v = li && li.querySelector('.int-sf__vid');
      if (!v) return;
      li.classList.remove('is-playing');
      v.pause();
      v.currentTime = 0;
    }, true);
  }

  function load() {
    fetch(root.dataset.feed, { mode: 'cors', credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (data) {
        items = (data && data.items) || [];
        if (!items.length) return;           // leave the section invisible
        grid.hidden = false;
        var shop = root.querySelector('.int-sf__shop');
        if (shop) shop.hidden = false;
        if (isCarousel()) {
          // New tiles append to the RIGHT, outside the visible scroll window,
          // so "View more" appears to do nothing even though it fired. Swiping
          // is already the reveal - render everything and hide the button.
          // render() sets btn.hidden itself once shown >= items.length.
          step = items.length;
          render();
        } else {
          step = parseInt(root.dataset.initial, 10) || step;
          render();
          step = parseInt(root.dataset.step, 10) || step;
          btn.addEventListener('click', render);
        }
        if (playVideo) wireHover();
      })
      .catch(function () { /* stay silent — an empty grid beats an error box */ });
  }

  // Only fetch once the section is near the viewport. On the homepage it sits
  // well below the fold, so this keeps it off the critical path entirely.
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) { io.disconnect(); load(); }
    }, { rootMargin: '400px' });
    io.observe(root);
  } else {
    load();
  }
});
});
